import Utils from '@/common/utils/utils';
import { IconButton, Tooltip } from '@material-ui/core';
import { useSetRecoilState } from 'recoil';
import { closePanelTabSelector, setPanelSelector } from '@/state/selector/panelSelector';

import Constant from '@/common/constant/Constant';

import { useRecoilValue } from 'recoil';
import { userAtom, userPermissionToViewKnowledgeAtom } from '@/state/atom/userAtom';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import { isShowVisibilityKnowledgeAtom } from '@/state/atom/ticketAtom';

import { getUserListCanMention } from '../handler/ChatThreadHandler';
import { getChatPostListByChatThreadId } from '@/service/chatPostService';
import { getAllChatThreadId } from '../handler/MessageHandler';
import { cloneDeep } from 'lodash';
import { useEffect } from 'react';
import { I18n } from 'aws-amplify';
import { generateDetatilTicketTitle } from '@/component/ticketList/handler/TicketHandler';
import { multiPanelAtom } from '@/state/atom/panelAtom';
import { isEmailTicket } from '../handler/ChatPostHandler';

export const TicketHead = ({ ...props }) => {
    const panelList = useRecoilValue(multiPanelAtom);
    const closePanelTab = useSetRecoilState(closePanelTabSelector);


    const addNewPanel = useSetRecoilState(setPanelSelector);
    // common userDetail state
    const userDetail = useRecoilValue(userAtom);
    const userPermissionView = useRecoilValue(userPermissionToViewKnowledgeAtom);
    const setIsShowVisibilityKnowledgeAtom = useSetRecoilState(isShowVisibilityKnowledgeAtom);

    const selectedProject = useRecoilValue(projectInuseDetailAtom);
    const isArchive = props.ticketInfo.liveOrArchived === Constant.LIVE_OR_ARCHIVED.ARCHIVED;

    const onOpenKnowledge = () => {
        const existedKnowledgeHelpdeskTicketListPanel = panelList.find(
            panel => (Constant.PANEL_TYPE.KNOWLEDGE_HELPDESK_TICKET_LIST, Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST).includes(panel.type)
        );
        
        if (!Utils.isEmptyObject(existedKnowledgeHelpdeskTicketListPanel)) {
            closePanelTab({
                event: null,
                panelType: existedKnowledgeHelpdeskTicketListPanel.type,
                panelId: existedKnowledgeHelpdeskTicketListPanel.id,
                tabId: 'knowledge_ticket_list_tab'
            });
        }

        let detailTicket = props.ticketInfo;
        
        let propsClone = {
            API: props.API,
            tabId: props.tabId,
            panelId: props?.panelId,
            chatThreadId: props?.chatThreadId,
            panelType: props?.panelType,
            componentName: props?.componentName,
        }
        console.log('onOpenKnowledge propsClone', propsClone)
        let addNewPanelParams = {
            type: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST,
            componentName: Constant.COMPONENT_NAME.LIST_TICKET_KNOWLEDGE,
            tabId: 'knowledge_ticket_list_tab',
            visibilitySettingType: Constant.VISIBILITY_SETTING_TYPE.PRIVATE,
            isCustomer: false,
            customerId: '',
            projectSelectedId: userPermissionView.projectSelectedId,
            corporationSelectedId: userPermissionView.corporationSelectedId,
            props : {
                ...propsClone,
                componentName: Constant.COMPONENT_NAME.LIST_TICKET_KNOWLEDGE,
                panelType: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST
            }
        }
        if (
            userPermissionView.projectSelectedId !== detailTicket.affiliationProject &&
            (userDetail?.id === detailTicket.customer || userPermissionView.projectSelectedId === detailTicket.customer)
        ) {
            setIsShowVisibilityKnowledgeAtom(false);

            addNewPanelParams.visibilitySettingType = Constant.VISIBILITY_SETTING_TYPE.CUSTOMER
            addNewPanelParams.isCustomer = true
            addNewPanelParams.customerId = detailTicket.customer
            addNewPanelParams.projectSelectedId = detailTicket.affiliationProject
            addNewPanelParams.corporationSelectedId = detailTicket.affiliationOrganization
        }
        addNewPanel(addNewPanelParams)                                                                          
    };

    const onChangeShowAllChatPost = async () => {
        props.setIsLoading(true);
        props.disableAutoScroll(false);
        
        let isShowAllChatPost = !props.isShowAllChatPost;
        await updateShowAllPostToWorkspace(isShowAllChatPost);

        let threadIdList = getAllChatThreadId(props, isShowAllChatPost, props.selectThread);
        let fromStart = 0;
        props.setFromMsg(fromStart);

        let postList = await getChatPostListByChatThreadId(props?.API, threadIdList, fromStart, selectedProject.id);
        let userListMention = await getUserListCanMention(props);
        userListMention = userListMention?.filter(user => user.active === 1)
        props.setUserListCanMention(userListMention);

        if (!Utils.isEmptyObject(postList)) {
            setTimeout(() => {
                props.setUserChatList(postList.userChatList);
            });
            props.setChatPostAllList({
                type: Constant.ACTION_CHANGE_LIST_DATA_TYPE.INITIAL,
                posts: postList ? postList.chatPostAllList : []
            });
            props.setLastedCountList(postList.chatPostAllList.length);
        }

        props.setIsShowAllChatPost(isShowAllChatPost);
        props.setIsLoading(false);
    };

    const updateShowAllPostToWorkspace = async (isShowAll) => {
        let panelId = props.panelId;
        let tabId = props.tabId;
        let panelListClone = cloneDeep(props.panelList);

        panelListClone.forEach(panel => {
            if(panel.id === panelId) {
                panel.tabList.forEach(tab => {
                    if(tab.id === tabId) {
                        tab.component.props.isShowAllChatPost = isShowAll;
                    }
                })
            }
        })
        props.setPanelList(panelListClone);
    }
    const getTitleOfTicketInfo = () => {
        if(props.ticketInfo.settingTitle){
            const titleList = [generateDetatilTicketTitle(props.ticketInfo)]
            return titleList
        }else{
            return props.ticketInfo.outline
            ? [JSON.parse(props.ticketInfo.outline)?.jp]
            : ['']
        }
    }
    useEffect(()=>{getTitleOfTicketInfo()},[props?.ticketInfo])

    const isShowBtnKnowledge = () => {
        if(isEmailTicket(props.ticketDetailSelected)) {
            return true;
        }
        if (
            props.ticketDetailSelected?.ticketType !== Constant.TICKET_TYPE.KNOWLEDGE ||
            props.ticketDetailSelected?.ticketType !== Constant.TICKET_TYPE.MASTER_KNOWLEDGE
        ) {
            return false;
        }
        
        if (userPermissionView.type !== Constant.USER_PERMISSION_VIEW_KNOWLEDGE.GUEST_PARTNER) {
            if(props.ticketDetailSelected.knowledgeService === Constant.STATUS_SERVICE_PERMISSION.OFF) {
                return false;
            }
            
            if (
                (props.corporationDetail?.knowledgeService === Constant.STATUS_SERVICE_PERMISSION.OFF &&
                    props.selectedProjectId === props.ticketInfo?.affiliationProject) ||
                [Constant.TICKET_TYPE.BROADCAST_PARENT, Constant.TICKET_TYPE.BROADCAST_CHILD].includes(
                    props.ticketDetailSelected?.ticketType
                )
            ) {
                return false;
            }
            return true;

        } else {
            if (userPermissionView.knowledgeService !== Constant.STATUS_SERVICE_PERMISSION.ON) {
                return false;
            }
            return true;
        }
    };

    const TooltipInKnowledge = () => {
        if (props.panelType === Constant.PANEL_TYPE.CUSTOMER_CHATTHREAD) {
            return I18n.get('KNOWLILB005')
        } else if (props.panelType === Constant.PANEL_TYPE.HELPDESK_CHATTHREAD) {
            return I18n.get('KNOWLITT002')
        } else {
            return ''
        }
    }

    return (
        <div className="headTicket">
            <div className="headTicket-chat">
                <div className="headTicket-fl">
                    <div
                        className="headline"
                        onClick={() => 
                            props.handleClickViewTicketDetail(
                                props,
                                props?.API,
                                props.selectThread.ticketId || props.ticketId,
                                props.ticketInfo,
                                props.chatPostAllList,
                                props.chatThreadId,
                                userDetail,
                                addNewPanel,
                                selectedProject
                            )
                        }
                    >
                        <div className="headline__thumb">
                            <img src="/assets/image/icon-check.svg" alt="" />
                        </div>
                        {props.isDisplayTicketHeadLine && (
                            <div className="headline__content">
                                <Tooltip
                                    title={
                                        props.ticketInfo.outline
                                            ? JSON.parse(props.ticketInfo.outline)?.jp
                                            : ''
                                    }
                                >
                                    <label className="titleDisplay titleTicket-titlev2 title-clamp" style={{ cursor: 'pointer' }}>
                                        {getTitleOfTicketInfo()}
                                    </label>
                                </Tooltip>
                            </div>
                        )}
                    </div>
                </div>
                {props.isShowHeadlineButtonGroup && (
                    <div className="headTicket-rg">
                        {props.threadChatList?.length > 1 ? (
                            <div className="ticketSwitch">
                                <p className="ticketSwitch-label">重ね表示</p>
                                <div className="switch-check">
                                    <input
                                        type="checkbox"
                                        id={`switch-show-all-chat-post-${props.panelId}`}
                                        defaultChecked={props.isShowAllChatPost}
                                        onChange={onChangeShowAllChatPost}
                                        disabled={!Utils.isEmptyString(props.ticketInfo.deletedAt)}
                                    />
                                    <label
                                        for={`switch-show-all-chat-post-${props.panelId}`}
                                    ></label>
                                </div>
                            </div>
                        ) : (
                            <div className="ticketSwitch-none"></div>
                        )}
                        {isShowBtnKnowledge() && (
                            <div className="itemButton">
                                <Tooltip title={TooltipInKnowledge()} placement='top' arrow >
                                    <IconButton
                                        className="itemNav"
                                        onClick={onOpenKnowledge}
                                        disabled={isArchive || !Utils.isEmptyString(props.ticketInfo.deletedAt)}
                                    >
                                        <img src="/assets/image/icon-link.svg" alt="" />
                                    </IconButton>
                                </Tooltip>
                            </div>     
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};
